import { type WorkspaceRepository } from '@telespot/domain';

/**
 * Use organization ID (and optional case type and search term) to count workspaces.
 */
export interface ICountWorkspacesQuery {
  /**
   * Count workspaces in an organization, optionally filtered by case type and search term.
   * @param organizationId The ID of the organization.
   * @param caseTypeId Optional case type ID to filter workspaces by case type.
   * @param searchTerm Optional search term to filter workspaces by name.
   * @returns The count. Undefined if the operation fails.
   */
  execute(organizationId: string, caseTypeId?: string, searchTerm?: string): Promise<number | undefined>;
}

export class CountWorkspacesQuery implements ICountWorkspacesQuery {
  constructor(private readonly workspaceRepository: WorkspaceRepository) {}

  public async execute(organizationId: string, caseTypeId?: string, searchTerm?: string): Promise<number | undefined> {
    try {
      return await this.workspaceRepository.count(organizationId, caseTypeId, searchTerm);
    } catch (error) {
      console.error('Error counting workspaces:', error);
      return undefined;
    }
  }
}
